import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="relative w-full bg-neutral-950 text-zinc-400 font-sans overflow-hidden border-t-4 border-red-700">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-[url('https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/37f7f16d-7c9c-4f81-b10c-2a08ddb4d637/dark-wood-texture.jpg')] bg-cover bg-center opacity-10 pointer-events-none z-0"
        aria-hidden="true"
      ></div>

      {/* Content Container */}
      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-8 z-10">
        
        {/* 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 mb-12">
          
          {/* Column 1: Firmainfo */}
          <div>
            <h3 className="text-2xl font-semibold tracking-wide pb-3 border-b border-zinc-800 mb-6 text-white">Firmainfo</h3>
            <div className="space-y-4 text-sm">
              <div>
                <p className="font-bold text-white text-base">Tømrerfirmaet Hansen &amp; Mortensen</p>
                <p className="text-zinc-400 mt-1.5 flex items-center gap-2">
                  <i className="fa-solid fa-location-dot text-red-700 w-4" aria-hidden="true" />
                  <span>Lillevangsvej 206, 3480 Fredensborg</span>
                </p>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-start gap-2">
                  <i className="fa-solid fa-phone text-red-700 w-4 mt-1" aria-hidden="true" />
                  <div>
                    <span className="font-bold text-zinc-300 block mb-0.5">Telefon:</span>
                    <div className="flex flex-col gap-1">
                      <a href="tel:22115514" className="text-red-500 hover:text-red-400 font-bold transition-colors">22 11 55 14</a>
                    </div>
                  </div>
                </div>
                
                <div className="flex items-start gap-2">
                  <i className="fa-solid fa-envelope text-red-700 w-4 mt-1" aria-hidden="true" />
                  <div>
                    <span className="font-bold text-zinc-300 block mb-0.5">E-mail:</span>
                    <a href="mailto:Hogm@hansenogmortensen.dk" className="text-red-500 hover:text-red-400 font-bold transition-colors break-all">Hogm@hansenogmortensen.dk</a>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-zinc-400">
                  <i className="fa-solid fa-id-card text-red-700 w-4" aria-hidden="true" />
                  <span><span className="font-bold text-zinc-300">CVR:</span> 20945036</span>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Quickmenu */}
          <div>
            <h3 className="text-2xl font-semibold tracking-wide pb-3 border-b border-zinc-800 mb-6 text-white">Quickmenu</h3>
            <ul className="space-y-3 text-sm font-bold">
              <li>
                <Link to="/" className="flex justify-between items-center py-1.5 text-zinc-300 hover:text-red-500 transition-colors border-b border-zinc-900/60">
                  <span>Hjem</span>
                  <span className="text-red-500 text-xs">&gt;</span>
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="flex justify-between items-center py-1.5 text-zinc-300 hover:text-red-500 transition-colors border-b border-zinc-900/60">
                  <span>Om os</span>
                  <span className="text-red-500 text-xs">&gt;</span>
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="flex justify-between items-center py-1.5 text-zinc-300 hover:text-red-500 transition-colors border-b border-zinc-900/60">
                  <span>Galleri</span>
                  <span className="text-red-500 text-xs">&gt;</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="flex justify-between items-center py-1.5 text-zinc-300 hover:text-red-500 transition-colors">
                  <span>Kontakt</span>
                  <span className="text-red-500 text-xs">&gt;</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Åbningstider */}
          <div>
            <h3 className="text-2xl font-semibold tracking-wide pb-3 border-b border-zinc-800 mb-6 text-white">Åbningstider</h3>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between py-1 border-b border-zinc-900/60">
                <span className="font-bold text-zinc-300">Mandag:</span>
                <span className="text-zinc-400">07:00 - 16:00</span>
              </div>
              <div className="flex justify-between py-1 border-b border-zinc-900/60">
                <span className="font-bold text-zinc-300">Tirsdag:</span>
                <span className="text-zinc-400">07:00 - 16:00</span>
              </div>
              <div className="flex justify-between py-1 border-b border-zinc-900/60">
                <span className="font-bold text-zinc-300">Onsdag:</span>
                <span className="text-zinc-400">07:00 - 16:00</span>
              </div>
              <div className="flex justify-between py-1 border-b border-zinc-900/60">
                <span className="font-bold text-zinc-300">Torsdag:</span>
                <span className="text-zinc-400">07:00 - 16:00</span>
              </div>
              <div className="flex justify-between py-1 border-b border-zinc-900/60">
                <span className="font-bold text-zinc-300">Fredag:</span>
                <span className="text-zinc-400">07:00 - 14:00</span>
              </div>
              <div className="flex justify-between text-red-500 font-bold py-1">
                <span>Weekend:</span>
                <span>Lukket</span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom copyright bar */}
        <div className="pt-6 border-t border-zinc-800/80 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-500">
            &copy; {new Date().getFullYear()} Tømrerfirmaet Hansen &amp; Mortensen. Alle rettigheder forbeholdes.
          </p>
        </div>

      </div>
    </footer>
  )
}
